var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrimsonFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.62 131.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#_1248-4);}.cls-2{fill:url(#_1248-3);}.cls-3{fill:url(#_1248-2);}.cls-4{fill:url(#_1321-3);}.cls-5{fill:url(#_1321-4);}.cls-6{fill:url(#_1321-2);}.cls-7{fill:url(#_1321-6);}.cls-8{fill:url(#_1321-5);}.cls-9{fill:url(#_236-12);}.cls-10{fill:url(#_236-11);}.cls-11{fill:url(#_236-16);}.cls-12{fill:url(#_236-10);}.cls-13{fill:url(#_236-15);}.cls-14{fill:url(#_236-14);}.cls-15{fill:url(#_236-13);}.cls-16{fill:url(#linear-gradient);}.cls-17{fill:url(#_127-2);}.cls-17,.cls-18,.cls-19{mix-blend-mode:color-dodge;}.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{opacity:.5;}.cls-18{fill:url(#_127-3);}.cls-31{fill:url(#_236);}.cls-19{fill:url(#_127);}.cls-32{fill:url(#_1321);}.cls-33{fill:url(#_1248);}.cls-34{fill:url(#New_Gradient_Swatch_5);}.cls-20{fill:url(#New_Gradient_Swatch_1);}.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{mix-blend-mode:multiply;}.cls-35{fill:url(#linear-gradient-3);}.cls-36{fill:url(#linear-gradient-4);}.cls-37{fill:url(#linear-gradient-2);}.cls-38{fill:url(#linear-gradient-5);}.cls-21{fill:url(#New_Gradient_Swatch_1-10);}.cls-22{fill:url(#New_Gradient_Swatch_1-11);}.cls-23{fill:url(#New_Gradient_Swatch_1-6);}.cls-24{fill:url(#New_Gradient_Swatch_1-9);}.cls-25{fill:url(#New_Gradient_Swatch_1-7);}.cls-26{fill:url(#New_Gradient_Swatch_1-4);}.cls-27{fill:url(#New_Gradient_Swatch_1-3);}.cls-28{fill:url(#New_Gradient_Swatch_1-8);}.cls-29{fill:url(#New_Gradient_Swatch_1-5);}.cls-30{fill:url(#New_Gradient_Swatch_1-2);}.cls-39{isolation:isolate;}.cls-40{fill:url(#_236-9);}.cls-41{fill:url(#_236-7);}.cls-42{fill:url(#_236-6);}.cls-43{fill:url(#_236-5);}.cls-44{fill:url(#_236-4);}.cls-45{fill:url(#_236-8);}.cls-46{fill:url(#_236-3);}.cls-47{fill:url(#_236-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_5",
    cx: 70.36,
    cy: 68.22,
    fx: -1.03,
    fy: 6.39,
    r: 110.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f1eff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c7c2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a198a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#817587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#66576e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#503e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3e2c48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#331e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2c1736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a1535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236",
    x1: 74.31,
    y1: 0,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 74.31,
    y1: 83.91,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5ba4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-2",
    x1: 74.31,
    y1: 129.92,
    x2: 74.31,
    y2: 1.93,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127",
    x1: 74.31,
    y1: -3964.34,
    x2: 74.31,
    y2: -3916.4,
    gradientTransform: "translate(0 -3916.4) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acbcdd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 23.79,
    y1: 64.8,
    x2: 23.79,
    y2: 86.3,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321",
    x1: -5916.95,
    y1: 859.81,
    x2: -5916.95,
    y2: 839.82,
    gradientTransform: "translate(-2021.29 5641.45) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85769c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e0ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-3",
    x1: -5914.5,
    y1: 837.98,
    x2: -5914.5,
    y2: 855.71,
    gradientTransform: "translate(-2021.29 5641.45) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-4",
    x1: -5930.71,
    y1: 842.51,
    x2: -5930.71,
    y2: 848.85,
    gradientTransform: "translate(-2021.29 5641.45) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-2",
    x1: -5936.12,
    y1: 851.03,
    x2: -5936.12,
    y2: 845.78,
    gradientTransform: "translate(-2021.29 5641.45) rotate(118.16)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248",
    x1: -5931.81,
    y1: 831.11,
    x2: -5931.81,
    y2: 837.65,
    gradientTransform: "translate(-2021.29 5641.45) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a5ba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1f3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: -5901.27,
    y1: 845.78,
    x2: -5901.27,
    y2: 844.24,
    gradientTransform: "translate(-2021.29 5641.45) rotate(118.16)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-5",
    x1: 4.83,
    y1: 57.22,
    x2: 0.44,
    y2: 65.9,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-2",
    x1: -10311.67,
    y1: 3211.94,
    x2: -10311.67,
    y2: 3191.95,
    gradientTransform: "translate(-2021.29 -10494.4) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-6",
    x1: -10309.22,
    y1: 3190.11,
    x2: -10309.22,
    y2: 3207.84,
    gradientTransform: "translate(-2021.29 -10494.4) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-7",
    x1: -10325.44,
    y1: 3194.48,
    x2: -10325.44,
    y2: 3201.02,
    gradientTransform: "translate(-2021.29 -10494.4) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-8",
    x1: -10330.84,
    y1: 3203.16,
    x2: -10330.84,
    y2: 3197.9,
    gradientTransform: "translate(-2021.29 -10494.4) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-2",
    x1: -10326.14,
    y1: 3183.7,
    x2: -10326.14,
    y2: 3190.12,
    gradientTransform: "translate(-2021.29 -10494.4) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-4",
    x1: -10295.99,
    y1: 3197.91,
    x2: -10295.99,
    y2: 3196.37,
    gradientTransform: "translate(-2021.29 -10494.4) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-9",
    x1: -0.18,
    y1: 81.87,
    x2: 5.98,
    y2: 77.39,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-3",
    x1: 19.46,
    y1: 71.54,
    x2: 3.04,
    y2: 59.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-5",
    x1: 10.82,
    y1: 58.22,
    x2: 10.82,
    y2: 72.25,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-6",
    x1: 10.82,
    y1: 21.03,
    x2: 10.82,
    y2: 35.06,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-7",
    x1: -4589.46,
    y1: 64.8,
    x2: -4589.46,
    y2: 86.3,
    gradientTransform: "translate(-4464.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-4",
    x1: -3740.14,
    y1: 4926.97,
    x2: -3740.14,
    y2: 4906.98,
    gradientTransform: "translate(-2443.34 5641.45) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-10",
    x1: -3737.69,
    y1: 4905.14,
    x2: -3737.69,
    y2: 4922.87,
    gradientTransform: "translate(-2443.34 5641.45) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-11",
    x1: -3753.9,
    y1: 4909.67,
    x2: -3753.9,
    y2: 4916.01,
    gradientTransform: "translate(-2443.34 5641.45) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-3",
    x1: -3759.31,
    y1: 4918.19,
    x2: -3759.31,
    y2: 4912.94,
    gradientTransform: "translate(-2443.34 5641.45) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-3",
    x1: 95.21,
    y1: 18.66,
    x2: 118.73,
    y2: 12.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-8",
    x1: -3724.46,
    y1: 4912.94,
    x2: -3724.46,
    y2: 4911.41,
    gradientTransform: "translate(-2443.34 5641.45) rotate(61.84) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-12",
    x1: -4608.42,
    y1: 57.22,
    x2: -4612.81,
    y2: 65.9,
    gradientTransform: "translate(-4464.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-5",
    x1: -8134.86,
    y1: 7279.1,
    x2: -8134.86,
    y2: 7259.11,
    gradientTransform: "translate(-2443.34 -10494.4) rotate(-61.84)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-13",
    x1: -8132.41,
    y1: 7257.27,
    x2: -8132.41,
    y2: 7275,
    gradientTransform: "translate(-2443.34 -10494.4) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-14",
    x1: -8148.63,
    y1: 7261.65,
    x2: -8148.63,
    y2: 7268.18,
    gradientTransform: "translate(-2443.34 -10494.4) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-15",
    x1: -8154.03,
    y1: 7270.32,
    x2: -8154.03,
    y2: 7265.07,
    gradientTransform: "translate(-2443.34 -10494.4) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-4",
    x1: -8149.33,
    y1: 7250.87,
    x2: -8149.33,
    y2: 7257.28,
    gradientTransform: "translate(-2443.34 -10494.4) rotate(-61.84)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-9",
    x1: -8119.18,
    y1: 7265.07,
    x2: -8119.18,
    y2: 7263.53,
    gradientTransform: "translate(-2443.34 -10494.4) rotate(-61.84)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-16",
    x1: -4613.43,
    y1: 81.87,
    x2: -4607.27,
    y2: 77.39,
    gradientTransform: "translate(-4464.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-6",
    x1: -4593.79,
    y1: 71.54,
    x2: -4610.22,
    y2: 59.97,
    gradientTransform: "translate(-4464.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-10",
    x1: -4602.43,
    y1: 58.22,
    x2: -4602.43,
    y2: 72.25,
    gradientTransform: "translate(-4464.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-11",
    x1: -4602.43,
    y1: 21.03,
    x2: -4602.43,
    y2: 35.06,
    gradientTransform: "translate(-4464.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -445,
    y1: 92.51,
    x2: -441.27,
    y2: 49.75,
    gradientTransform: "translate(-383.11 -3.51) rotate(-177.7) scale(1.06 -.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e30617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97b03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -339.93,
    y1: 43.44,
    x2: -338.35,
    y2: 25.26,
    gradientTransform: "translate(-240.44 -26.69) rotate(-164.27) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -458.9,
    y1: 89.67,
    x2: -452.64,
    y2: 18,
    gradientTransform: "translate(-360.2 -7.07) rotate(-177.7) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -314.19,
    y1: -44.42,
    x2: -312.86,
    y2: -59.56,
    gradientTransform: "translate(-199.13 -47.13) rotate(-156.24) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -506.1,
    y1: 175.47,
    x2: -520.04,
    y2: 208.38,
    gradientTransform: "translate(-489.49 49.19) rotate(161.3) scale(1 -1.02)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 74.31,
    cy: 65.93,
    r: 63.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m74.32,0C37.9,0,8.39,29.52,8.39,65.93s29.52,65.93,65.93,65.93,65.93-29.52,65.93-65.93S110.73,0,74.32,0Zm0,128.16c-16.62,0-32.25-6.47-44-18.23-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01c-11.75,11.75-27.38,18.23-44,18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m74.32,130.05c-29.77,0-54.97-19.4-63.44-46.14,7.83,27.67,33.27,47.94,63.44,47.94s55.61-20.27,63.44-47.94c-8.48,26.74-33.67,46.14-63.44,46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m119.57,20.67C107.48,8.58,91.41,1.93,74.32,1.93s-33.16,6.66-45.25,18.75c-12.09,12.09-18.74,28.16-18.74,45.25s6.66,33.16,18.74,45.25c12.09,12.09,28.16,18.74,45.25,18.74s33.17-6.66,45.25-18.74c12.09-12.09,18.74-28.16,18.74-45.25s-6.66-33.17-18.74-45.25Zm-1.25,89.26c-11.75,11.75-27.38,18.23-44,18.23s-32.25-6.47-44-18.23c-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m137.76,47.94C129.93,20.27,104.49,0,74.32,0S18.7,20.27,10.87,47.94C19.35,21.2,44.55,1.99,74.32,1.99s54.97,19.21,63.44,45.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m21.11,98.93l1.72,5.03s.43,1.37-.28,2.8l3.93,4.53-.52-6.18-4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.96,18.03c-2.91,9.79-7.21,17.51-7.21,17.51-.98,2.17-2.33,5.08-2.33,5.08-.57,1.24-1.56,3.84-1.56,3.84,2.82-3.12,4.66-5.85,6.82-8.67,4.17-5.45,7.01-15.06,8.4-20.66.65-2.63.99-4.37.99-4.37,2.42-1.17,3.7-1.9,3.85-1.98.22-.11.45-.21.67-.31-.99-1.3-2.2-2.27-2.2-2.27-3.74-.56-5.28,1.48-5.28,1.48-.23,1.88-.54,3.7-.91,5.44-.37,1.72-.79,3.36-1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m17.43,40.62s2.11-4.66,2.25-4.9c0,0,4.38-7.9,7.29-17.69.46-1.56.89-3.2,1.26-4.91,0,0,.75,13.06-10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m31.39,15.89s-.45.46-1.8,4.68c0,0,.46-5.89,1.99-10.6,0,0,1.6-2.99,2.85-3.75.19.16,1.72,1.19,3.97,4.41-.22.1-.91.64-1.13.75-.15.09-2.43,1.73-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m29.13,7.68s1.33-1.77,4.52-1.57c-1.36,1.86-3.95,2.3-4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m31.39,15.89l.97-2.77c1.29-1.73,2.77-2.63,2.77-2.63,0,0,1.31.19,2.57.62l-.42.28c-3.05,2.01-5.88,4.51-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m18.15,41.78s.83-2.07,1.43-3.99l.85-3.5c-.12.15-.52,1.06-.67,1.24-1.61,3.22-2.54,5.26-3.89,8.92,0,0,1.64-1.96,2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m10.32,50.03s-4.56,4.81-7.29,15.9H0s.72-12.21,12.37-22.62l-2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m26.96,113.82c-2.91-9.79-7.21-17.51-7.21-17.51-.98-2.17-2.33-5.08-2.33-5.08-.57-1.24-1.56-3.84-1.56-3.84,2.82,3.12,4.66,5.85,6.82,8.67,4.17,5.45,7.01,15.06,8.4,20.66.65,2.63.99,4.37.99,4.37,2.42,1.17,3.7,1.9,3.85,1.98.22.11.45.21.67.31-.99,1.3-2.2,2.27-2.2,2.27-3.74.56-5.28-1.48-5.28-1.48-.23-1.88-.54-3.7-.91-5.44-.37-1.72-.79-3.36-1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m17.43,91.24s2.11,4.66,2.25,4.9c0,0,4.38,7.9,7.29,17.69.46,1.56.89,3.2,1.26,4.91,0,0,.75-13.06-10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m31.05,115.61s-.11-.11-1.46-4.33c0,0,.46,5.89,1.99,10.6,0,0,1.6,2.99,2.85,3.75.19-.16,3.4-3.02,4.3-4.2-.22-.1-1.69-1.17-1.91-1.28-.15-.09-2.9-1.86-5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m29.13,124.17s1.33,1.77,4.52,1.57c-1.36-1.86-3.95-2.3-4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m31.05,115.61l.82,2.29c.61,2.08,2.11,3.67,2.11,3.67,0,0,1.06.22,2.01-.28l1.2-.89c-.61-.33-4.12-3.04-6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m18.15,90.07s.83,2.07,1.43,3.99l.85,3.5c-.12-.15-.52-1.06-.67-1.24-1.61-3.22-2.54-5.26-3.89-8.92,0,0,1.64,1.96,2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m10.32,81.82s-4.56-4.81-7.29-15.9H0s.72,12.21,12.37,22.62l-2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m3.03,65.93c2.59-10.81,7.29-15.9,7.29-15.9l1.17-3.85C2.86,54.36,1.46,65.93,1.46,65.93c0,0,1.4,11.57,10.03,19.74l-1.17-3.85s-4.7-5.09-7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.27,80.49s.36,2.19.3,3.18l.74,2.91,2.05,1.97-.88-2.88-1.17-3.85-1.05-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "12.37 43.3 11.49 46.18 10.32 50.03 9.27 51.36 9.27 48.53 11.49 44.11 12.37 43.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m127.52,98.93l-1.72,5.03s-.43,1.37.28,2.8l-3.93,4.53.52-6.18,4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m121.66,18.03c2.91,9.79,7.21,17.51,7.21,17.51.98,2.17,2.33,5.08,2.33,5.08.57,1.24,1.56,3.84,1.56,3.84-2.82-3.12-4.66-5.85-6.82-8.67-4.17-5.45-7.01-15.06-8.4-20.66-.65-2.63-.99-4.37-.99-4.37-2.42-1.17-3.7-1.9-3.85-1.98-.22-.11-.45-.21-.67-.31.99-1.3,2.2-2.27,2.2-2.27,3.74-.56,5.28,1.48,5.28,1.48.23,1.88.54,3.7.91,5.44.37,1.72.79,3.36,1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m131.2,40.62s-2.11-4.66-2.25-4.9c0,0-4.38-7.9-7.29-17.69-.46-1.56-.89-3.2-1.26-4.91,0,0-.75,13.06,10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.24,15.89s.45.46,1.8,4.68c0,0-.46-5.89-1.99-10.6,0,0-1.6-2.99-2.85-3.75-.19.16-1.72,1.19-3.97,4.41.22.1.91.64,1.13.75.15.09,2.43,1.73,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m119.5,7.68s-1.33-1.77-4.52-1.57c1.36,1.86,3.95,2.3,4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m117.24,15.89l-.97-2.77c-1.29-1.73-2.77-2.63-2.77-2.63,0,0-1.31.19-2.57.62l.42.28c3.05,2.01,5.88,4.51,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m130.48,41.78s-.83-2.07-1.43-3.99l-.85-3.5c.12.15.52,1.06.67,1.24,1.61,3.22,2.54,5.26,3.89,8.92,0,0-1.64-1.96-2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m138.31,50.03s4.56,4.81,7.29,15.9h3.03s-.72-12.21-12.37-22.62l2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m121.66,113.82c2.91-9.79,7.21-17.51,7.21-17.51.98-2.17,2.33-5.08,2.33-5.08.57-1.24,1.56-3.84,1.56-3.84-2.82,3.12-4.66,5.85-6.82,8.67-4.17,5.45-7.01,15.06-8.4,20.66-.65,2.63-.99,4.37-.99,4.37-2.42,1.17-3.7,1.9-3.85,1.98-.22.11-.45.21-.67.31.99,1.3,2.2,2.27,2.2,2.27,3.74.56,5.28-1.48,5.28-1.48.23-1.88.54-3.7.91-5.44.37-1.72.79-3.36,1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m131.2,91.24s-2.11,4.66-2.25,4.9c0,0-4.38,7.9-7.29,17.69-.46,1.56-.89,3.2-1.26,4.91,0,0-.75-13.06,10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m117.58,115.61s.11-.11,1.46-4.33c0,0-.46,5.89-1.99,10.6,0,0-1.6,2.99-2.85,3.75-.19-.16-3.4-3.02-4.3-4.2.22-.1,1.69-1.17,1.91-1.28.15-.09,2.9-1.86,5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m119.5,124.17s-1.33,1.77-4.52,1.57c1.36-1.86,3.95-2.3,4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.58,115.61l-.82,2.29c-.61,2.08-2.11,3.67-2.11,3.67,0,0-1.06.22-2.01-.28l-1.2-.89c.61-.33,4.12-3.04,6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m130.48,90.07s-.83,2.07-1.43,3.99l-.85,3.5c.12-.15.52-1.06.67-1.24,1.61-3.22,2.54-5.26,3.89-8.92,0,0-1.64,1.96-2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m138.31,81.82s4.56-4.81,7.29-15.9h3.03s-.72,12.21-12.37,22.62l2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m145.6,65.93c-2.59-10.81-7.29-15.9-7.29-15.9l-1.17-3.85c8.63,8.18,10.03,19.74,10.03,19.74,0,0-1.4,11.57-10.03,19.74l1.17-3.85s4.7-5.09,7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m139.35,80.49s-.36,2.19-.3,3.18l-.74,2.91-2.05,1.97.88-2.88,1.17-3.85,1.04-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "136.25 43.3 137.13 46.18 138.31 50.03 139.35 51.36 139.35 48.53 137.13 44.11 136.25 43.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m91.06,99.56c-5.83-4.67-15.62-7.56-20.17-13.97-5.32-7.51-5.35-19.69,2.7-25.65-1.13,4.5.04,9.47,2.26,13.12,2.22,3.65,5.38,6.16,8.59,8.28s6.58,3.94,9.56,6.56c2.13,1.87,4.09,4.22,5.15,7.24.94,2.69,1.64,6.12.44,8.73s-6.43,8.41-9.93,8.06c5.36-3.53,5.11-9.39,1.39-12.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m71.79,93.51c3.46,2.01,6.84,4.05,10.55,5.7,14.36,6.36,7.88,11.31,3.71,13.07,4.65-4.93-1.86-5.92-9.94-7.83-4.69-1.11-8.12-3.13-10.85-6.55-2.73-3.43-4.16-8.96-1.65-13.19,1.46,4.03,4.72,6.79,8.18,8.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m92.1,112.28c7.91-.58,17.18-5.93,19.75-13.42,2.57-7.48,1.24-16.06-2.61-22.67-6.1-10.48-13.16-12.48-15.52-20,.04.05.08.1.12.16-.15-.41-.28-.81-.41-1.2-.04-.17-.08-.35-.11-.53-.38-3.58.73-5.8.73-5.8-.7,2.44,1.06,4.45,1.06,4.45-.12-3.99,4.04-7.18,4.04-7.18-1.44,2.86.51,5.94,1.91,9.03,1.4,3.08.27,7.57.27,7.57,2.09-.8,4.94-6.96,4.94-6.96,2.37-.25,3.9-3.79,3.92-8.23.02-4.44-5.79-12.76-5.79-12.76-4.66-8.78-1.06-13.41-1.06-13.41-4.74,2.8-2.7,15.04-2.7,15.04-3.23-4.69-11.75-7.01-11.75-7.01,3.88,1.79,9.04,8.7,9.04,8.7-1.25,1-8.58-2.81-8.58-2.81-.41.87,2.54,3.79,2.54,3.79-1.58-.43-5.56,1.11-5.56,1.11-7.14,2.47-10.75.43-10.75.43,1.28,3.68,6.5,4.58,6.5,4.58-3.73,2.14-8.87.4-8.87.4,1.02,1.92,7.89,3.29,7.89,3.29,0,0,.03.09.07.24-1.43,2.23-2.33,4.97-2.43,8.16-.59,19.16,21.8,19.28,24.34,41.65.51,4.46-3.81,10.03-10.96,13.37Zm11.12-61.47c.06-.26,1.09-4.37.72-5.15,0,0,1.63,3.99.48,7.07,0,0-.16.5-.1.8-.27-.58-1.14-2.5-1.09-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m108.39,21.83s-3.03,5.85-1.22,9.9c2.78,6.23,3.25,10.93,3.25,10.93-1.94-5.25-3.17-4.19-6.14-10.58,0,0-1.52-3.79,4.11-10.26Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m58.63,109.74c-6.56-2.69-11.58-6.36-14.97-12.21-2.52-4.34-4.18-10.1-3.04-17.44,1.08-13.23,6.11-27.91-1.31-42.34,3,23.87-8.97,30.9-7.41,50.16h0c.87,14.54,15.54,20.84,15.54,20.84,4.48,2.36,17.48,5.12,26.67,4.25,0,0-10.8-1.34-15.48-3.26Zm26.13,2.19c-27.69-5.79-28.51-23.24-21.64-39.87,7.27-17.58,14.68-39.38-1.3-55.37,6.94,16.54,1.37,31.58-4.83,45.42-.98,2.19-1.43,3.23-1.93,4.95v.03c-.94,3.07-1.85,6.18-2.52,9.36-1.75,8.14-1.72,17.16,2.71,24.17,4.07,6.45,14.5,9.67,21.02,10.42m3.9,1.24c-31.57-4.29-33.87-16.94-29.35-37.13,3.7-16.48,13.55-31.81.9-50.43,3.74,15.37-1.25,26.74-5.78,38.69-2.01,5.31-3.38,10.95-3.89,16.75,0,.03,0,.06,0,.09-1.64,20.23,12.27,28.47,26.83,30.78"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrimsonFlame);
export default __webpack_public_path__ + "static/media/crimson-flame.4fc45f56fe913a9da7430b47435f09dc.svg";
export { ForwardRef as ReactComponent };